import Breadcrumbs from '@components/controls/Breadcrumbs';

import { scale, typography } from '@scripts/gds';

export const BlockBreadcrumbs = ({ items }: { items: { name: string; link: string }[] }) => (
    <Breadcrumbs
        css={{
            paddingTop: scale(3, true),
            ...typography('bodySm'),
            lineHeight: 1.5,
        }}
    >
        {items?.map(({ name, link }: any, index: number) => (
            <Breadcrumbs.Item key={link} link={link} isLastItem={index === items.length - 1} index={index}>
                {name}
            </Breadcrumbs.Item>
        ))}
    </Breadcrumbs>
);
